import React, { Component } from 'react';
import { Grid, Table, ButtonToolbar } from 'react-bootstrap';
import { PropTypes } from 'prop-types';

import { EditionsCommand } from '../commands/EditionsCommand';
import { EditionEditSingleIntervalForm } from './forms/EditionEditSingleIntervalForm';
import { EditionEditMultipleIntervalsForm } from './forms/EditionEditMultipleIntervalsForm';
import { EditionCopyForm } from './forms/EditionCopyForm';
import { PaginationBuilder } from '../../PaginationBuilder';
import { PaginationHelper } from '../../helpers/PaginationHelper';
import { SearchHelper } from '../../helpers/SearchHelper';
import { LoadingSpinner } from '../../LoadingSpinner';
import { HandleMessage } from '../../HandleMessage';
import { HandleDialog } from '../../HandleDialog';
import { TableButton } from '../../TableButton';
import { SortIndicator } from '../../SortIndicator';
import { AddOnsHelper } from '../../helpers/AddOnsHelper';
import ColumnResize from "react-table-column-resizer";

export class EditionsList extends Component {
    static contextTypes = {
        selectedProvider: PropTypes.string,
        edition: PropTypes.object
    }

    constructor(props) {
        super(props);

        this.state = {
            actions: {
                isLoading: true,
                isUpdating: false,
                isCopying: false,
                isDeleting: false
            },
            data: [],
            form: {
                edit: {
                    show: false,
                    operation: "",
                    obj: undefined,
                    nameInputError: null,
                    nameErrorMessage: "O Nome da edição não pode ser vazio!",
                    startDateInputError: null,
                    startDateErrorMessage: "A Data de Início introduzida é inválida!",
                    endDateInputError: null,
                    endDateErrorMessage: "A Data de Fim introduzida é inválida!",
                },
                copy: {
                    show: false,
                    obj: undefined,
                    dependencies: undefined,
                    nameInputError: null,
                    nameErrorMessage: "O Nome da edição não pode ser vazio!",
                    editionInputError: null,
                    editionErrorMessage: "A edição não pode ser vazia!",
                },
                validationCallback: undefined
            },
            commands: {
                editions: new EditionsCommand()
            },
            pagination: {
                currentPage: 1,
                elementsPerPage: 50,
            },
            render: {
                sort: {
                    property: "id",
                    type: "ascending"
                }
            },
            message: {
                show: false,
                message: undefined,
                style: undefined,
                icon: undefined,
                title: ""
            },
            dialog: {
                show: false,
                message: undefined,
                style: undefined,
                icon: undefined,
                title: "",
                argument: undefined
            }
        };

        if ("function" === typeof props.listCallback) {
            props.listCallback(() => this.listEditions());
        }

        if ("function" === typeof props.refreshCallback) {
            props.refreshCallback(() => this.getEditions());
        }
    }

    componentDidMount() {
        this.getEditions();
    }

    // -----------------------

    listEditions() {
        const { data } = this.state;
        return data;
    }

    getEditions() {
        const { actions, commands } = this.state;
        const { type } = this.props;
        let selectedProviderId = '';

        actions.isLoading = true;

        if (this.context.selectedProvider !== undefined) {
            selectedProviderId = this.context.selectedProvider.split(':')[0];
        }

        this.setState({
            actions: actions
        });

        commands.editions.get(
            type,
            selectedProviderId,
            (a) => this.listSuccessCallback(a),
            (a) => this.listErrorCallback(a)
        );
    }

    // -----------------------

    listSuccessCallback(result) {
        const { actions } = this.state;

        actions.isLoading = false;

        // Update table
        this.setState({
            data: result,
            actions: actions
        });
    }

    listErrorCallback(message) {
        const { actions, pagination } = this.state;

        actions.isLoading = false;
        pagination.currentPage = 1;

        this.setState({
            data: [],
            pagination: pagination,
            actions: actions,
            message: {
                show: true,
                message: message,
                style: "danger",
                title: "Erro",
                icon: "remove"
            }
        });
    }

    operationSuccessCallback(operation) {
        const { edition } = this.context;
        const { actions } = this.state;
        let message = "";

        switch (operation) {
            case "publish":
                message = "Edição Publicada com Sucesso!";
                actions.isUpdating = false;
                break;

            case "archive":
                message = "Edição Arquivada com Sucesso!";
                actions.isUpdating = false;
                break;

            case "edit":
                message = "Edição Editada com Sucesso!";
                actions.isUpdating = false;
                break;

            case "delete":
                message = "Edição Eliminada com Sucesso!";
                actions.isDeleting = false;
                break;

            case "copy":
                message = "Edição Copiada com Sucesso!";
                actions.isCopying = false;
                break;

            default:
                message = "Operação executada com Sucesso!";
                break;
        }

        // Update Provider selected Editions
        if (null !== edition && undefined !== edition) {
            edition.update(edition.date, undefined, true);
        }

        this.setState({
            actions: actions,
            message: {
                show: true,
                message: message,
                style: "success",
                title: "Sucesso",
                icon: "ok"
            }
        });

        this.getEditions();
    }

    operationErrorCallback(message) {
        const { actions } = this.state;

        actions.isUpdating = false;
        actions.isCopying = false;
        actions.isDeleting = false;

        this.setState({
            actions: actions,
            message: {
                show: true,
                message: message,
                style: "danger",
                title: "Erro",
                icon: "remove"
            }
        });

        this.getEditions();
    }

    // -----------------------

    editionEditValidation(operation, obj) {
        const { form } = this.state;

        form.edit.nameInputError = this.editionNameValidation(obj.name);

        if (undefined === obj.intervals || null === obj.intervals || !Array.isArray(obj.intervals)) {
            form.edit.startDateInputError = this.editionStartDateValidation(operation, obj.state, obj.startDate);
            form.edit.endDateInputError = this.editionEndDateValidation(obj.startDate, obj.endDate);
        }
        else {
            form.edit.startDateInputError = null;
            form.edit.endDateInputError = null;

            obj.intervals.forEach(interval => {
                const intervalStartDateInputError = this.editionStartDateValidation(operation, obj.state, interval.startDate);
                const intervalEndDateInputError = this.editionEndDateValidation(interval.startDate, interval.endDate);

                if (null !== intervalStartDateInputError) { form.edit.startDateInputError = intervalStartDateInputError; }
                if (null !== intervalEndDateInputError) { form.edit.endDateInputError = intervalEndDateInputError; }
            });
        }

        this.setState({
            form: form
        });

        return null === form.edit.nameInputError && null === form.edit.startDateInputError && null === form.edit.endDateInputError;
    }

    editionCopyValidation(obj) {
        const { type } = this.props;
        const { form } = this.state;

        form.copy.nameInputError = this.editionNameValidation(obj.name);
        if ("planning" === type) {
            form.copy.editionInputError = this.editionNetworkEditionInputError(obj.networkEditionId, form.copy.dependencies.networkEditions || []);
        }

        this.setState({
            form: form
        });

        return null === form.copy.nameInputError && null === form.copy.editionInputError;
    }

    editionNameValidation(name) {
        if (undefined === name || null === name || "" === name) {
            return "error";
        }

        return null;
    }

    editionStartDateValidation(operation, state, startDate) {
        if (undefined === startDate || null === startDate || "" === startDate) {
            return (0 === state || "0" === state) && "edit" === operation ? null : "error";
        }

        if ("Invalid Date" === new Date(startDate)) {
            return "error";
        }

        return null;
    }

    editionEndDateValidation(startDate, endDate) {
        if (undefined === endDate || null === endDate || "" === endDate) {
            return null;
        }

        const endDateObj = new Date(endDate);
        if ("Invalid Date" === endDateObj) {
            return "error";
        }

        if (undefined === startDate || null === startDate || "" === startDate) {
            return "error";
        }

        const startDateObj = new Date(startDate);
        if (endDateObj < startDateObj) {
            return "error";
        }

        return null;
    }

    editionNetworkEditionInputError(networkEditionId, list) {
        if (0 !== networkEditionId && undefined === list.find(a => a.id === networkEditionId)) {
            return "error";
        }

        return null;
    }

    // -----------------------

    onChangeSort(property) {
        const { render } = this.state;

        render.sort.type = render.sort.property === property && "ascending" === render.sort.type ? "descending" : "ascending";
        render.sort.property = property;

        this.setState({
            render: render
        });
    }

    onChangePage(page) {
        const { pagination } = this.state;

        pagination.currentPage = page;

        this.setState({
            pagination: pagination
        });
    }

    onChangeElementsPerPage(elements) {
        const { pagination } = this.state;

        pagination.elementsPerPage = elements;

        this.setState({
            pagination: pagination
        });
    }

    onChangeEditForm(e, property) {
        const { form } = this.state;

        form.edit.obj[property] = e.target.value;
        if ("function" === typeof form.validationCallback) {
            form.validationCallback(form.edit.operation, form.edit.obj);
        }
        else {
            form.edit.nameInputError = "error";
            form.edit.startDateInputError = "error";
            form.edit.endDateInputError = "error";
        }

        this.setState({
            form: form
        });
    }

    onChangeCopyForm(e, property) {
        const { form } = this.state;

        form.copy.obj[property] = e.target.value;
        if ("function" === typeof form.validationCallback) {
            form.validationCallback(form.copy.obj);
        }
        else {
            form.copy.nameInputError = "error";
            form.copy.editionInputError = "error";
        }

        this.setState({
            form: form
        });
    }

    onSelectCopyForm(e, property) {
        const { form } = this.state;

        form.copy.obj[property] = e;
        if ("function" === typeof form.validationCallback) {
            form.validationCallback(form.copy.obj);
        }
        else {
            form.copy.nameInputError = "error";
            form.copy.editionInputError = "error";
        }

        this.setState({
            form: form
        });
    }

    onChangeDateEditForm(e, property) {
        const { form } = this.state;

        form.edit.obj[property] = undefined === e || null === e || "" === e ? e : e.split("T")[0];
        if ("function" === typeof form.validationCallback) {
            form.validationCallback(form.edit.operation, form.edit.obj);
        }
        else {
            form.edit.nameInputError = "error";
            form.edit.startDateInputError = "error";
            form.edit.endDateInputError = "error";
        }

        this.setState({
            form: form
        });
    }

    onChangeIntervalDateEditForm(e, interval, property) {
        const { form } = this.state;

        const objInterval = form.edit.obj.intervals.find(objInterval => objInterval === interval);
        objInterval[property] = undefined === e || null === e || "" === e ? e : e.split("T")[0];
        if ("function" === typeof form.validationCallback) {
            form.validationCallback(form.edit.operation, form.edit.obj);
        }
        else {
            form.edit.nameInputError = "error";
            form.edit.startDateInputError = "error";
            form.edit.endDateInputError = "error";
        }

        this.setState({
            form: form
        });
    }

    onAddIntervalEditForm() {
        const { form } = this.state;

        form.edit.obj.intervals.push({
            id: 0,
            startDate: "",
            endDate: ""
        });

        this.setState({
            form: form
        });
    }

    onRemoveIntervalEditForm(interval) {
        const { form } = this.state;

        form.edit.obj.intervals = form.edit.obj.intervals.filter(objInterval => objInterval !== interval);

        this.setState({
            form: form
        });
    }

    onSaveEditForm() {
        const { type } = this.props;
        const { form } = this.state;
        let isValid = false;

        if ("function" === typeof form.validationCallback) {
            isValid = form.validationCallback(form.edit.operation, form.edit.obj);
        }
        else {
            form.edit.nameInputError = "error";
            form.edit.startDateInputError = "error";
            form.edit.endDateInputError = "error";
        }

        if (isValid) {
            const { actions, commands } = this.state;

            actions.isUpdating = true;

            switch (form.edit.operation) {
                case "edit":
                    commands.editions.save(
                        type,
                        form.edit,
                        () => this.operationSuccessCallback(form.edit.operation),
                        (a) => this.operationErrorCallback(a)
                    );
                    break;

                case "publish": // FALL THROUGH
                case "archive":
                    commands.editions.updateState(
                        type,
                        form.edit,
                        () => this.operationSuccessCallback(form.edit.operation),
                        (a) => this.operationErrorCallback(a)
                    );
                    break;

                default:
                    actions.isUpdating = false;
                    break;
            }

            this.setState({
                actions: actions
            });

            this.onHideEditForm();
        }
        else {
            this.setState({
                form: form
            });
        }
    }

    onSaveCopyForm() {
        const { type } = this.props;
        const { form } = this.state;
        let isValid = false;

        if ("function" === typeof form.validationCallback) {
            isValid = form.validationCallback(form.copy.obj);
        }
        else {
            form.copy.nameInputError = "error";
            form.copy.editionInputError = "error";
        }

        if (isValid) {
            const { actions, commands } = this.state;

            commands.editions.copy(
                type,
                form.copy,
                () => this.operationSuccessCallback("copy"),
                (a) => this.operationErrorCallback(a)
            );

            actions.isCopying = true;

            this.setState({
                actions: actions
            });

            this.onHideCopyForm();
        }
        else {
            this.setState({
                form: form
            });
        }
    }

    onHideEditForm() {
        const { form } = this.state;

        form.edit.show = false;

        this.setState({
            form: form
        });
    }

    onHideCopyForm() {
        const { form } = this.state;

        form.copy.show = false;

        this.setState({
            form: form
        });
    }

    // -----------------------

    onAddOnClick(name, label, edition) {
        this.props.onExecuteAddOn(name, label, edition.id);
    }

    onCopyClick(edition) {
        const { type } = this.props;
        const { form } = this.state;

        form.copy.show = true;
        form.copy.obj = {
            originalId: edition.id,
            name: edition.name
        };
        form.copy.dependencies = "function" === typeof this.props.dependenciesCallback ? this.props.dependenciesCallback() : undefined;
        form.copy.nameInputError = null;
        form.copy.editionInputError = null;
        form.validationCallback = (a) => this.editionCopyValidation(a);

        if ("planning" === type) {
            form.copy.obj.networkEditionId = 0;
        }

        this.setState({
            form: form
        });
    }

    onEditClick(edition) {
        const { form } = this.state;

        form.edit.show = true;
        form.edit.operation = "edit";
        form.edit.obj = Object.assign({}, edition);
        form.edit.nameInputError = null;
        form.edit.startDateInputError = null;
        form.edit.endDateInputError = null;
        form.validationCallback = (a, b) => this.editionEditValidation(a, b);

        if (Array.isArray(form.edit.obj.intervals)) {
            form.edit.obj.intervals = form.edit.obj.intervals.map(interval => Object.assign({}, interval));
        }

        this.setState({
            form: form
        });
    }

    onDeleteClick(edition) {
        this.setState({
            dialog: {
                show: true,
                message: `Tem a certeza que pretende eliminar a Edição "${edition.name}"?`,
                style: "warning",
                icon: "alert",
                title: "Aviso",
                argument: {
                    editionId: edition.id,
                    operation: "delete-edition"
                }
            }
        });
    }

    onPublishClick(edition) {
        const { form } = this.state;

        form.edit.show = true;
        form.edit.operation = "publish";
        form.edit.obj = Object.assign({}, edition);
        form.edit.nameInputError = null;
        form.edit.startDateInputError = null;
        form.edit.endDateInputError = null;
        form.validationCallback = (a, b) => this.editionEditValidation(a, b);

        if (Array.isArray(form.edit.obj.intervals)) {
            form.edit.obj.intervals = form.edit.obj.intervals.map(interval => Object.assign({}, interval));
        }

        this.setState({
            form: form
        });
    }

    onArchiveClick(edition) {
        const { form } = this.state;

        form.edit.show = true;
        form.edit.operation = "archive";
        form.edit.obj = Object.assign({}, edition);
        form.edit.nameInputError = null;
        form.edit.startDateInputError = null;
        form.edit.endDateInputError = null;
        form.validationCallback = (a, b) => this.editionEditValidation(a, b);

        if (Array.isArray(form.edit.obj.intervals)) {
            form.edit.obj.intervals = form.edit.obj.intervals.map(interval => Object.assign({}, interval));
        }

        this.setState({
            form: form
        });
    }

    onExitMessage() {
        this.setState({
            message: {
                show: false,
                title: undefined,
                message: undefined,
                style: undefined,
                icon: undefined
            }
        });
    }

    onExitDialog(isToExecute, argument) {
        const { actions } = this.state;
        let isValid = true;

        if (isToExecute) {
            const { type } = this.props;
            const { commands } = this.state;

            switch (argument.operation) {
                case "delete-edition":
                    actions.isDeleting = true;
                    commands.editions.delete(
                        type,
                        argument.editionId,
                        () => this.operationSuccessCallback("delete"),
                        (a) => this.operationErrorCallback(a)
                    );
                    break;

                default:
                    isValid = false;
                    break;
            }
        }

        if (!isValid) {
            this.setState({
                message: {
                    show: true,
                    message: "Não foi possível executar a operação requerida.",
                    style: "danger",
                    title: "Erro",
                    icon: "remove"
                }
            });
        }

        this.setState({
            actions: actions,
            dialog: {
                show: false,
                message: undefined,
                style: undefined,
                icon: undefined,
                title: "",
                argument: undefined
            }
        });
    }

    // -----------------------

    sortEditions(sort, a, b) {
        let aValue = a[sort.property];
        let bValue = b[sort.property];

        if ("object" === typeof aValue) {
            aValue = undefined !== aValue.left ? aValue.left : aValue.right;
        }

        if ("object" === typeof bValue) {
            bValue = undefined !== bValue.left ? bValue.left : bValue.right;
        }

        if (aValue === bValue) {
            return 0;
        }

        const output = aValue < bValue ? -1 : 1;

        if ("descending" === sort.type) {
            return output * -1;
        }

        return output;
    }

    // -----------------------

    renderSortIndicator(property, sort) {
        if (property !== sort.property) {
            return (
                <SortIndicator order="none" />
            );
        }

        return (
            <SortIndicator order={sort.type} />
        );
    }

    renderEditForm() {
        const { form } = this.state;

        if (!form.edit.show) {
            return null;
        }

        const { type } = this.props;

        if ("network" === type) {
            return (
                <EditionEditSingleIntervalForm value={form.edit.obj}
                    operation={form.edit.operation}
                    nameInputError={form.edit.nameInputError}
                    nameErrorMessage={form.edit.nameErrorMessage}
                    startDateInputError={form.edit.startDateInputError}
                    startDateErrorMessage={form.edit.startDateErrorMessage}
                    endDateInputError={form.edit.endDateInputError}
                    endDateErrorMessage={form.edit.endDateErrorMessage}
                    onChangeValue={(a, b) => this.onChangeEditForm(a, b)}
                    onChangeDateValue={(a, b) => this.onChangeDateEditForm(a, b)}
                    onSave={() => this.onSaveEditForm()}
                    onHide={() => this.onHideEditForm()} />
            );
        }

        if ("planning" === type) {
            return (
                <EditionEditMultipleIntervalsForm value={form.edit.obj}
                    operation={form.edit.operation}
                    nameInputError={form.edit.nameInputError}
                    nameErrorMessage={form.edit.nameErrorMessage}
                    startDateInputError={form.edit.startDateInputError}
                    startDateErrorMessage={form.edit.startDateErrorMessage}
                    endDateInputError={form.edit.endDateInputError}
                    endDateErrorMessage={form.edit.endDateErrorMessage}
                    onChangeValue={(a, b) => this.onChangeEditForm(a, b)}
                    onChangeDateValue={(a, b, c) => this.onChangeIntervalDateEditForm(a, b, c)}
                    onAddIntervalEditForm={() => this.onAddIntervalEditForm()}
                    onRemoveIntervalEditForm={(a) => this.onRemoveIntervalEditForm(a)}
                    onSave={() => this.onSaveEditForm()}
                    onHide={() => this.onHideEditForm()} />
            );
        }

        if ("county" === type) {
            return (
                <EditionEditSingleIntervalForm value={form.edit.obj}
                    operation={form.edit.operation}
                    nameInputError={form.edit.nameInputError}
                    nameErrorMessage={form.edit.nameErrorMessage}
                    startDateInputError={form.edit.startDateInputError}
                    startDateErrorMessage={form.edit.startDateErrorMessage}
                    endDateInputError={form.edit.endDateInputError}
                    endDateErrorMessage={form.edit.endDateErrorMessage}
                    onChangeValue={(a, b) => this.onChangeEditForm(a, b)}
                    onChangeDateValue={(a, b) => this.onChangeDateEditForm(a, b)}
                    onSave={() => this.onSaveEditForm()}
                    onHide={() => this.onHideEditForm()} />
            );
        }
    }

    renderCopyForm() {
        const { form } = this.state;

        if (!form.copy.show) {
            return null;
        }

        const { type } = this.props;

        return (
            <EditionCopyForm value={form.copy.obj}
                type={type}
                dependencies={form.copy.dependencies}
                nameInputError={form.copy.nameInputError}
                nameErrorMessage={form.copy.nameErrorMessage}
                editionInputError={form.copy.editionInputError}
                editionErrorMessage={form.copy.editionErrorMessage}
                onChangeValue={(a, b) => this.onChangeCopyForm(a, b)}
                onSelectValue={(a, b) => this.onSelectCopyForm(a, b)}
                onSave={() => this.onSaveCopyForm()}
                onHide={() => this.onHideCopyForm()} />
        );
    }

    renderState(state) {
        let label = "";

        switch (state) {
            case 0:
            case "0":
                label = "Rascunho";
                break;

            case 1:
            case "1":
                label = "Publicada";
                break;

            case 3:
            case "3":
                label = "Arquivada";
                break;

            default: break;
        }

        return label;
    }

    renderDateValue(date) {
        if (undefined === date || null === date || "" === date) {
            return "---";
        }

        return date;
    }

    renderDate(obj, arrayProperty, dateProperty) {
        if (undefined === obj[arrayProperty] || null === obj[arrayProperty] || !Array.isArray(obj[arrayProperty])) {
            return this.renderDateValue(obj[dateProperty]);
        }
        else {
            return (
                obj[arrayProperty].map(value =>
                    <p key={`p-${dateProperty}-${value.id}`}>{this.renderDateValue(value[dateProperty])}</p>
                )
            );
        }
    }

    renderNoButton(marginRight = true) {
        return (
            <TableButton marginRight={marginRight} />
        );
    }

    renderAddOn(addOn, edition) {
        if (undefined === addOn || null === addOn || !addOn.enabled) {
            return null;
        }

        return (
            <TableButton
                key={addOn.name}
                marginRight
                icon={AddOnsHelper.getIcon(addOn.icon)}
                onClick={() => this.onAddOnClick(addOn.name, addOn.label, edition)}
                title={addOn.label} />
        );
    }

    renderAddOns(edition) {
        const { getAddOnsCallback } = this.props;

        if ("function" !== typeof getAddOnsCallback) {
            return null;
        }

        const addOns = getAddOnsCallback();
        if (!Array.isArray(addOns) || 0 === addOns.length) {
            return null;
        }

        return (
            <React.Fragment>
                {addOns.map(addOn => this.renderAddOn(addOn, edition))}
            </React.Fragment>
        );
    }

    renderCopyButton(value) {
        return (
            <TableButton
                marginRight
                icon="icon-copy"
                title="Copiar"
                onClick={() => this.onCopyClick(value)} />
        );
    }

    renderEditButton(value) {
        const { state } = value;

        if (0 === state || "0" === state || 1 === state || "1" === state) {
            return (
                <TableButton
                    marginRight
                    icon="icon-edit"
                    title="Editar"
                    onClick={() => this.onEditClick(value)} />
            );
        }

        return this.renderNoButton();
    }

    renderDeleteButton(value) {
        const { state } = value;

        if (3 === state || "3" === state || 1 === state || "1" === state) {
            return this.renderNoButton();
        }

        return (
            <TableButton
                marginRight
                icon="icon-trash"
                title="Eliminar"
                onClick={() => this.onDeleteClick(value)} />
        );
    }

    renderNextStateButton(value) {
        const { state } = value;

        if (0 === state || "0" === state) {
            return (
                <TableButton
                    icon="icon-ok"
                    title="Publicar"
                    onClick={() => this.onPublishClick(value)} />
            );
        }

        if (1 === state || "1" === state) {
            return (
                <TableButton
                    icon="icon-box"
                    title="Arquivar"
                    onClick={() => this.onArchiveClick(value)} />
            );
        }

        return this.renderNoButton(false);
    }

    renderLoading(isLoading) {
        if (isLoading) {
            return (
                <LoadingSpinner />
            );
        }

        return null;
    }

    render() {
        const { actions, data, pagination, render, message, dialog } = this.state;
        const { type, filter, isLoading } = this.props;

        const dataFiltered = SearchHelper.search({
            filter: filter,
            data: data,
            fields: ["name", "startDate", "endDate", "state"],
            valueParser: {
                "state": {
                    "0": "rascunho",
                    "1": "publicada",
                    "2": "fechada",
                    "3": "arquivada"
                }
            }
        });

        const totalPages = PaginationHelper.getTotalPages(dataFiltered.length, pagination.elementsPerPage);
        const activePage = totalPages < pagination.currentPage ? totalPages : pagination.currentPage;
        const dataToRender = dataFiltered
            .sort((a, b) => this.sortEditions(render.sort, a, b))
            .slice((activePage - 1) * pagination.elementsPerPage, activePage * pagination.elementsPerPage);

        return (
            <Grid fluid className="table-small-screens">
                <div className="table-loading">
                    <Table responsive striped hover>
                        <thead>
                            <tr>
                                <th className="sortable" onClick={() => this.onChangeSort("name")}>Nome {this.renderSortIndicator("name", render.sort)}</th>
                                <ColumnResize className="columnResizer" />
                                <th className="sortable" onClick={() => this.onChangeSort("state")}>Estado {this.renderSortIndicator("state", render.sort)}</th>
                                <ColumnResize className="columnResizer" />
                                <th>Data Início</th>
                                <ColumnResize className="columnResizer" />
                                <th>Data Fim</th>
                                <ColumnResize className="columnResizer" />
                                <th>&nbsp;</th>
                            </tr>
                        </thead>
                        <tbody className={actions.isLoading || isLoading ? "overlay" : ""}>
                            {
                                dataToRender.map((value, idx) =>
                                    <tr key={`edition-${type}-${idx}`}>
                                        <td>{value.name}</td>
                                        <td className="column_resizer_body" />
                                        <td>{this.renderState(value.state)}</td>
                                        <td className="column_resizer_body" />
                                        <td>{this.renderDate(value, "intervals", "startDate")}</td>
                                        <td className="column_resizer_body" />
                                        <td>{this.renderDate(value, "intervals", "endDate")}</td>
                                        <td className="column_resizer_body" />
                                        <td>
                                            <ButtonToolbar className="pull-right">
                                                {this.renderAddOns(value)}
                                                {this.renderCopyButton(value)}
                                                {this.renderEditButton(value)}
                                                {this.renderDeleteButton(value)}
                                                {this.renderNextStateButton(value)}
                                            </ButtonToolbar>
                                        </td>
                                    </tr>
                                )
                            }
                        </tbody>
                    </Table>

                    <PaginationBuilder
                        currentPage={pagination.currentPage}
                        elementsPerPage={pagination.elementsPerPage}
                        dataLength={dataFiltered.length}
                        onChangePage={(a) => this.onChangePage(a)}
                        onChangeElementsPerPage={(a) => this.onChangeElementsPerPage(a)} />

                    {this.renderLoading(actions.isLoading || isLoading)}
                </div>

                {this.renderEditForm()}
                {this.renderCopyForm()}

                <HandleMessage
                    title={message.title}
                    message={message.message}
                    style={message.style}
                    icon={message.icon}
                    show={message.show}
                    onHide={() => this.onExitMessage()} />

                <HandleMessage
                    title="A Executar"
                    message={<LoadingSpinner />}
                    style={`primary`}
                    icon="transfer"
                    show={actions.isCopying || actions.isDeleting || actions.isUpdating}
                    noButtons
                    small />

                <HandleDialog
                    title={dialog.title}
                    message={dialog.message}
                    argument={dialog.argument}
                    style={dialog.style}
                    icon={dialog.icon}
                    show={dialog.show}
                    onExit={(a, b) => this.onExitDialog(a, b)} />
            </Grid>
        );
    }
}
